import { EventSourceParserStream } from 'eventsource-parser/stream'

interface ReadEventStreamOptions<T> {
    stream: ReadableStream<BufferSource>
    parse: (event: string | undefined, raw: unknown) => T | undefined
    onMessage: (msg: T) => void | boolean | Promise<void | boolean>
}

export const readEventStream = async <T>({ stream, parse, onMessage }: ReadEventStreamOptions<T>) => {
    const parsedStream = stream.pipeThrough(new TextDecoderStream()).pipeThrough(new EventSourceParserStream())
    const reader = parsedStream.getReader()
    try {
        while (true) {
            const { done, value } = await reader.read()
            if (done) {
                return
            }

            const { event, data } = value

            if (!data) {
                continue
            }

            const rawMsg = JSON.parse(data)

            const msg = parse(event, rawMsg)
            if (!msg) {
                continue
            }

            const shouldKeepReading = await onMessage(msg)
            if (shouldKeepReading === false) {
                return
            }
        }
    } finally {
        reader.releaseLock()
    }
}
